import React from "react";
import { IconProps } from "../icon";

export const Server_02Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6 8h.01M6 16h.01M6 12h12M6 12a4 4 0 010-8h12a4 4 0 010 8M6 12a4 4 0 000 8h12a4 4 0 000-8"
    />
  </svg>
);
